/**
 *  字体选择组件
 */
import { Select } from 'antd';
import { getFonts } from '@/common/constants/font';


function getFontGroupOptions() {
    const fonts = getFonts();
    const cursiveGroup = fonts.filter(font => font.isCursive).map(font => ({ label: font.label, value: font.value, style: { fontFamily: `${font.value}, cursive` } }));
    const nonCursiveGroup = fonts.filter(font => !font.isCursive).map(font => ({ label: font.label, value: font.value, style: { fontFamily: `${font.value}, sans-serif` } }));
    return [
        {
            label: <span>常用字体</span>,
            title: '常用字体',
            options: nonCursiveGroup
        },
        {
            label: <span>手写字体</span>,
            title: '手写字体',
            options: cursiveGroup
        },
    ]
}

interface FontSelectProps {
    fontName: string;
    onChange: (fontName: string) => void;
    className?: string;
}

const fontOptions = getFontGroupOptions();

function FontSelect(props: FontSelectProps) {
    const { fontName, onChange, className } = props;
    return (
        <Select variant="filled" className={className} onChange={onChange} value={fontName} options={fontOptions} />
    )
}

export default FontSelect;